import home1YinliuLogo from '@/assets/img/home1_yinliu_logo.png'

export default {
  data () {
    return {
      //  引导页\贷超\被拒引流产品名称
      productName: 'Dana Jelas',
      //  引导页\贷超\被拒下载链接
      downloadUrl: 'https://apps.apple.com/id/app/dana-jelas-pinjaman-online/id6762964902?l=id&uo=4',
      home1_yinliu_logo: home1YinliuLogo
    }
  },
  methods: {

  }
}
